export default __webpack_public_path__ + "static/media/step8-2.8f65f589.jpg";